import { ANIMATED_TYPE } from 'utils/constants';

export const ANIMATION_CASE_STUDY_PROPS = {
  type: ANIMATED_TYPE.isFade,
  duration: 1000,
};
